import { Component } from '@verndale/core';
import axios from 'axios';

import FormValidator from '../components/form-validator';

class ContactForm extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.el._$('.contact-form__form'),
      $heading: this.el._$('h2'),
      $success: this.el._$('.contact-form__success'),
      $submitBtn: this.el._$('.contact-form__submit-btn'),
      $buttonReset: this.el._$('.contact-form__reset'),
      $buttonTryAgain: this.el._$('.contact-form__try-again'),
      $alertError: this.el._$('.contact-form__alert-error')
    };

    this.headingSuccess = this.el.dataset.headingSuccess;
    this.headingDefault = this.el.dataset.headingDefault;
    this.fetchUrl = this.dom.$form.dataset.fetchUrl;
    this.formValidator = new FormValidator(this.dom.$form);
  }

  addListeners() {
    const { $form, $buttonReset, $buttonTryAgain } = this.dom;

    $form._on('submit', ::this.handleSubmit);
    $form._on('change', ::this.handleChange);
    $form._on('input', ::this.handleChange);
    $buttonTryAgain._on('submit', ::this.handleSubmit);
    $buttonReset._on('click', ::this.handleReset);
  }

  handleChange() {
    const { $submitBtn } = this.dom;

    if (this.formValidator.validate(false)) {
      $submitBtn.disabled = false;
    } else {
      $submitBtn.disabled = true;
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const {
      $heading,
      $form,
      $alertError,
      $success,
      $buttonTryAgain,
      $submitBtn
    } = this.dom;
    const formData = Array.from(new window.FormData(e.target));
    const data = Array.from(formData.entries()).reduce(
      (memo, [index, [key, value]]) => ({
        ...memo,
        [key]: value
      }),
      {}
    );

    if (this.formValidator.validate()) {
      axios
        .post(this.fetchUrl, data)
        .then(() => {
          $form.hidden = true;
          $success.hidden = false;
          $alertError.hidden = true;
          $buttonTryAgain.hidden = true;
          $heading.textContent = this.headingSuccess;
        })
        .catch(() => {
          $form.hidden = false;
          $success.hidden = true;
          $alertError.hidden = false;
          $buttonTryAgain.hidden = false;
          $submitBtn.hidden = true;
        });
    }
  }

  handleReset() {
    const {
      $form,
      $alertError,
      $success,
      $buttonTryAgain,
      $heading,
      $submitBtn
    } = this.dom;

    this.formValidator.reset();
    $form.hidden = false;
    $success.hidden = true;
    $alertError.hidden = true;
    $buttonTryAgain.hidden = true;
    $heading.textContent = this.headingDefault;
    $submitBtn.disabled = true;
  }
}

export default ContactForm;
